import { Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import { DeliveryZoneCharge } from '../../types/delivery-zone.type';
import { NO_CHARGES_LABEL, toChargeRanges } from '../../utils/delivery-zone-charges.util';

type Props = {
  charges: DeliveryZoneCharge[];
};

const useStyles = makeStyles({
  ranges: {
    display: 'grid',
    gridTemplateColumns: 'auto auto',
    columnGap: '1rem',
    rowGap: '0.125rem',
    justifyContent: 'start',
    whiteSpace: 'nowrap',
    fontVariantNumeric: 'tabular-nums',
  },
  cost: {
    textAlign: 'right',
  },
});

export function DeliveryZoneChargesSummary({ charges }: Props) {
  const classes = useStyles();
  const ranges = toChargeRanges(charges);

  if (ranges.length === 0) return <span>{NO_CHARGES_LABEL}</span>;

  return (
    <div className={classes.ranges}>
      {ranges.map((chargeRange) => (
        <Fragment key={chargeRange.range}>
          <span>{chargeRange.range}</span>
          <span className={classes.cost}>{chargeRange.cost}</span>
        </Fragment>
      ))}
    </div>
  );
}
